// removed by extract-text-webpack-plugin
module.exports = {"menuContainer":"dh-farlige-land-cover-menuContainer","menu":"dh-farlige-land-cover-menu","menu__scroller":"dh-farlige-land-cover-menu__scroller","menu__left":"dh-farlige-land-cover-menu__left","menu__right":"dh-farlige-land-cover-menu__right","menu__item":"dh-farlige-land-cover-menu__item","menu__item--current":"dh-farlige-land-cover-menu__item--current","menu--fixed":"dh-farlige-land-cover-menu--fixed"};


//////////////////
// WEBPACK FOOTER
// ./src/v1/menu/components/Menu/index.css
// module id = 20
// module chunks = 0